import { DetailText, Text } from "../../components/units/Text"
import { BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import { useSearchParams } from "react-router-dom"
import { Input } from "../../components/Form/FormInput"
import { SubmitButton } from "../../components/Buttons/buttons"
import { RestApiState } from "../../components/Rest/Organization"
import { useEffect, useState } from "react"
import { AxiosConfirmPassword } from "../../components/Rest/RestorePassword"
import { AxiosValidateUrl } from "../../components/Rest/RestorePassword"


interface UrlProps {
    uid: string;
    token: string;
}


const useParams = (): UrlProps => {
    const [params] = useSearchParams()
    const uid = params.get("uid")
    const token = params.get("token")

    if (uid && token) {
        return {
            uid : uid,
            token : token
        }
    }

    throw new Error("Required params not provided")
}


interface ConfirmPasswordProps {
    uid? : string;
    token?: string;
    newPassword: string;
    confirmPassword: string;
    requestState: RestApiState;
    timeOutId: NodeJS.Timeout | null;
    requestSent: boolean;
    errorStatus?: string;
    urlValidation: RestApiState;

}


const defaultProps = ():ConfirmPasswordProps  => {
    return {
        newPassword: "", 
        confirmPassword: "", 
        requestState: RestApiState.Idle,
        timeOutId: null,
        requestSent: false,
        errorStatus: undefined,
        urlValidation: RestApiState.Idle,

    }
}


export const ConfirmPasswordView = (): JSX.Element => {
    const params: UrlProps = useParams()
    const [props, setProps] = useState<ConfirmPasswordProps>(defaultProps())
    const [isValidUrl, setValidUrl] = useState<boolean>(false)

    useEffect(() => {
        if (props.requestState === RestApiState.Success) {
            setProps((prev) => ({...prev, requestSent: true}))
            setProps(prev => ({...prev, newPassword: ""}))
            setProps(prev => ({...prev, confirmPassword: ""}))

        }

    }, [props.requestState])

    useEffect(() => {
        if (props.urlValidation === RestApiState.Idle) {
            const data = {uid: params.uid, token: params.token}
            setProps( propv => ({...props, urlValidation: RestApiState.Pending}) )
            AxiosValidateUrl(data, (value: RestApiState) => { setProps( propv => ({...props, urlValidation: value}) ) })
        }

    }, [])

    useEffect(() => {
        if (props.urlValidation === RestApiState.Success) {
            const intervalId = setInterval(() => {
                setValidUrl(true);
            }, 2000);

            return () => clearInterval(intervalId);
        }

    }, [props.urlValidation])


    const classifyErros = ():void => {
        // Refactor into switch case.
        if (props.confirmPassword.length === 0 || props.confirmPassword.length === 0 ) {
            return void setProps(props => ({
                ...props, errorStatus : "Поля не заполнены"
            }))
        };

        if (props.newPassword !== props.confirmPassword) {
            return void setProps(props => ({
                ...props, errorStatus : "Пароли не совпадают"
            }))
        };

        if (props.newPassword.length <= 8) {
            return void setProps(props => ({
                ...props, errorStatus : "Слабый пароль"
            }))
        };
        return;
    };

    const formValid = () => {
        if (props.newPassword === props.confirmPassword && props.newPassword.length > 8) {
            return true
        } else {
            return false
        }
    }

    const handleSubmit = (e: any):void => {
        e.preventDefault()
        const data = {uid: params.uid, token: params.token, new_password: props.newPassword, confirm_password: props.confirmPassword}
        if (formValid()) {
            setProps(props => ({...props, requestState : RestApiState.Pending}))
            return void AxiosConfirmPassword(
                data, 
                (value: RestApiState) => {setProps(props => ({...props, requestState : value}))},
                (error: string) => { return void setProps(prev => ({...prev, errorStatus: error}))}
            )
        } else {
            return void classifyErros()
        }
    }


    return (
        <div className="AuthViewContainer">
            <div className="content-wrapper relative">
                <div className="logo relative">
                    <img src="https://portal.stark-lithium.ru/static/website/img/logo-dark.png" alt="" />
                    <svg className="drill" width="485" height="32" viewBox="0 0 485 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: "absolute", bottom: "25%", left: "-500px"}}>
                        <path d="M464.822 6.43723L463.654 10.6742H482.043L485 0.00564294H473.523C471.545 0.00706313 469.622 0.637877 468.052 1.80049C466.483 2.9631 465.354 4.59272 464.84 6.43723H464.822ZM423.935 21.3371H405.563L408.52 10.6742H426.892L423.935 21.3371ZM313.685 21.3371H295.313L298.275 10.6742H316.671L313.685 21.3371ZM188.048 10.6742L185.091 21.3371H166.702L169.659 10.6742H188.048ZM111.562 21.3371H93.2017L96.1643 10.6742H114.536L111.562 21.3371ZM1.30597 21.3371H-17.0487L-14.0743 10.6855H4.3037L1.30597 21.3371ZM448.215 0.00564294H418.366C416.387 0.00515972 414.463 0.635257 412.893 1.79816C411.323 2.96107 410.195 4.59176 409.683 6.43723L408.514 10.6742H390.142L393.099 0.00564294H363.244C361.266 0.00735293 359.344 0.638377 357.776 1.80104C356.207 2.96371 355.079 4.59317 354.566 6.43723L353.397 10.6742H335.02L337.982 0.00564294H271.366C269.388 0.00735293 267.466 0.638377 265.897 1.80104C264.329 2.96371 263.201 4.59317 262.688 6.43723L261.519 10.6742H243.147L240.19 21.3371H221.824L224.781 10.6742H243.153L246.116 0.0112859H161.139C159.162 0.0120006 157.241 0.642063 155.674 1.80383C154.106 2.9656 152.979 4.5942 152.467 6.43723L151.298 10.6685H132.909L135.871 0H106.017C104.039 0.000758638 102.116 0.631426 100.547 1.79424C98.9785 2.95705 97.8507 4.58706 97.3389 6.43159L96.1701 10.6685H77.7864L80.7491 0H50.8943C48.9164 0.000758638 46.9941 0.631426 45.4252 1.79424C43.8563 2.95705 42.7285 4.58706 42.2166 6.43159L41.0479 10.6685H22.6641L25.6268 0H-40.9546C-42.9325 0.000758638 -44.8549 0.631426 -46.4238 1.79424C-47.9927 2.95705 -49.1205 4.58706 -49.6323 6.43159L-50.801 10.6685H-69.214L-72.1709 21.3314H-90.5371L-87.5803 10.6685H-69.2023L-66.2455 0.00564294H-96.1002C-98.0783 0.00544839 -100.001 0.635756 -101.57 1.79871C-103.139 2.96167 -104.267 4.59222 -104.778 6.43723L-105.947 10.6685H-124.33L-121.368 0.00564294H-151.222C-153.201 0.00611234 -155.124 0.636565 -156.694 1.79932C-158.264 2.96208 -159.393 4.59224 -159.906 6.43723L-161.075 10.6685H-142.703L-145.659 21.3314H-164.037L-167 31.9943H-155.488C-153.51 31.9945 -151.587 31.3642 -150.018 30.2012C-148.449 29.0383 -147.321 27.4077 -146.811 25.5627L-145.642 21.3314H-127.264L-130.227 31.9943H-63.5925C-61.6136 31.9948 -59.6899 31.3647 -58.1198 30.2018C-56.5497 29.0389 -55.4211 27.4082 -54.909 25.5627L-53.7403 21.3314H-35.3682L-38.3309 31.9943H-8.47617C-6.49803 31.9945 -4.57515 31.3642 -3.00604 30.2012C-1.43695 29.0383 -0.309418 27.4077 0.201523 25.5627L1.37024 21.3314H19.7599L16.803 31.9943H46.6052C48.5833 31.9945 50.5062 31.3642 52.0753 30.2012C53.6444 29.0383 54.7719 27.4077 55.2828 25.5627L56.4516 21.3314H74.8003L71.8376 31.9943H138.454C140.432 31.9945 142.355 31.3642 143.924 30.2012C145.493 29.0383 146.621 27.4077 147.132 25.5627L148.3 21.3314H166.673L163.716 31.9943H248.769C250.748 31.9957 252.672 31.366 254.242 30.203C255.813 29.0399 256.941 27.4087 257.452 25.5627L258.621 21.3314H276.993L274.036 31.9943H303.885C305.865 31.9976 307.791 31.3695 309.363 30.2075C310.936 29.0455 312.067 27.4146 312.58 25.5684L313.749 21.3371H332.121L329.158 31.9999H358.99C360.968 32.0001 362.891 31.3698 364.46 30.2069C366.029 29.0439 367.156 27.4134 367.667 25.5684L368.836 21.3371H387.185L384.222 31.9999H432.455C434.433 32.0001 436.356 31.3698 437.925 30.2069C439.494 29.0439 440.622 27.4134 441.132 25.5684L442.301 21.3371H460.679L463.636 10.6742H445.264L448.215 0.00564294Z" fill="#FF8200"/>
                    </svg>
                </div>
                
                {  !isValidUrl && (
                    <BoxWrapper bg="bg-primary" r="r10" style={{height: "120px"}} className="show-up-quick">
                        <FlexWrapper className="full-height" flexDirection="column" alignItems="center" justifyContent="center">
                            <FlexWrapper>
                                { props.urlValidation !== RestApiState.BadRequest ? (
                                    <>
                                        <Text className="bold">Проверка ссылки</Text>
                                        <div className="btnloader"></div>
                                    </>
                                ) : (
                                    <Text className="bold">
                                        Ссылка больше не активна, 
                                        <DetailText href="/react/">попробуйте снова</DetailText>
                                    </Text>
                                ) }
                            </FlexWrapper>
                        </FlexWrapper> 
                    </BoxWrapper>
                ) }
            
                { isValidUrl && (
                    <>                
                    { !props.requestSent ? (
                        <BoxWrapper className="relative no-scroll-bar show-up-quick" p="p0" style={{height:"412px", overflow: "scroll"}} >
                            <form onSubmit={handleSubmit}>                    
                                <Input
                                    label="Новый пароль"
                                    type="password"
                                    name="new-password"
                                    required={true}
                                    setter={ (e:any):void => { return void setProps(props => ({...props, newPassword: e.target.value})) } }
                                />
                                <Input
                                    label="Подвердите пароль"
                                    type="password"
                                    name="confirm-password"
                                    required={true}
                                    setter={ (e:any):void => { return void setProps(props => ({...props, confirmPassword: e.target.value})) } }

                                />
                                <BoxWrapper style={{height: "38px"}}>
                                    <FlexWrapper alignItems="center" justifyContent="center">
                                        <Text>{props.errorStatus}</Text>
                                    </FlexWrapper>
                                </BoxWrapper>

                                <SubmitButton restState={props.requestState}
                                    disabled={false}
                                    onClick={ (e:any):void => {
                                        if (!formValid()) {
                                            e.preventDefault()
                                            return void classifyErros()
                                        }
                                    }}
                                    text={"Сменить пароль"}
                                    restHandler={{
                                        timeOutId: props.timeOutId,
                                        setter: (key: 'timeOutId' | 'requestState', value: any):void => {
                                            return void setProps(props => ({
                                                ...props, [key] : value
                                            }))
                                        }
                                    }}
                                />
                            </form>
                        </BoxWrapper>
                    ): (
                        <BoxWrapper className="show-up-quick" style={{height:"412px"}} p="p0">
                            <BoxWrapper p="p0">
                                <Text className="text-center">Пароль успешно сменен ✅</Text>
                                <div className="btn-controlls margin-top-5">
                                    <button 
                                        onClick={(e) => { window.location.href = '/react/'}}
                                        >К авторизации</button>
                                </div>
                            </BoxWrapper>
                        </BoxWrapper>
                    )}
                    </>
                )}
                <FlexWrapper alignItems="center" justifyContent="center">
                    <DetailText color="secondary" href="/react/policy">Политика конфиденциальности</DetailText>
                </FlexWrapper>
            </div>
        </div>
    )
}